<!-- Item Start Outlet -->
<ng-template [cxOutlet]="CartOutlets.ITEM">
  <div [ngClass]="compact ? 'cx-compact row' : 'row'">
    <!-- Item Image -->
    <div class="col-2 cx-image-container">
      <a
        [routerLink]="{ cxRoute: 'product', params: item.product } | cxUrl"
        cxModal="dismiss"
        tabindex="-1"
        >
        <cx-media
          [container]="item.product.images?.PRIMARY"
          format="product"
        ></cx-media>
      </a>
      <app-uig-marketplace-icon [marketplace]="item.product.marketplace" [vendor]="item.product.vendor"></app-uig-marketplace-icon>
    </div>
    <!-- Item Information -->
    <div class="cx-info col-10 cart-item__info">
      <!-- Zero quantity product warning -->
      @if (item.quantity === 0) {
        <div  class="cx-info-container row zero-qty-warning">
          {{ "fastEntry.errors.zeroQty" | cxTranslate }}
        </div>
      }
      <div class="cx-info-container row">
        <!-- Item Description -->
        <div [ngClass]="compact ? '' : ' col-md-4'">
          @if (item.product.name) {
            <div class="cx-name">
              <a
                class="cx-link"
              [routerLink]="
                { cxRoute: 'product', params: item.product } | cxUrl
              "
                cxModal="dismiss"
                ><h2 class="uig-cart-item-name">{{ item.product.name }}</h2></a
                >
              </div>
            }
            @if (item.product.code) {
              <div class="product-item-spec">
                <div class="row">
                  <div class="col-6 col-xl-4">{{ "uigCartItems.id" | cxTranslate }}</div>
                  <div class="col-6 col-xl-8">{{ item.product.code }}</div>
                </div>
              </div>
            }
            @if (item.product.minDecline) {
              <div class="product-item-spec">
                <div class="row">
                  <div class="col-6 col-xl-4">{{ "uigCartItems.le" | cxTranslate }}</div>
                  <div class="col-6 col-xl-8">{{ item.product.minDecline }}</div>
                </div>
              </div>
            }
            <!-- Item Details Outlet -->
            <ng-template [cxOutlet]="CartOutlets.ITEM_DETAILS"> </ng-template>

            <!-- Variants -->
            <!-- <ng-container *ngIf="item.product.baseOptions?.length">
            <div
                *ngFor="
                  let variant of item.product.baseOptions[0]?.selected
                    ?.variantOptionQualifiers
                "
              class="cx-property"
              >
              <div class="cx-label" *ngIf="variant.name && variant.value">
                {{ variant.name }}: {{ variant.value }}
              </div>
            </div>
          </ng-container> -->
        </div>
        <div class="cart-item__availability-icon col-12 col-md-1">
          <app-uig-availability
            [product]="item.product"
            [iconOnly]="true"
          ></app-uig-availability>
        </div>
        <!-- Item Price -->
        @if (item.basePrice) {
          <div
            class="cx-price"
            [ngClass]="compact ? '' : ' col-12 col-md-2'"
            >
            <div
              class="cx-label"
              [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'"
              >
              {{ "uigCartItems.itemPrice" | cxTranslate }}
            </div>
            @if (item.basePrice) {
              <div class="cx-value">
                {{ item.basePrice?.formattedValue }}
              </div>
            }
          </div>
        }
        <!-- Item Quantity -->
        <div class="cx-quantity" [ngClass]="compact ? '' : ' col-12 col-md-3'">
          <div
            class="cx-label"
            [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'"
            placement="left"
            title="{{ 'uigCartItems.quantityTitle' | cxTranslate }}"
            >
            {{ "uigCartItems.quantity" | cxTranslate }}
          </div>
          <div class="cx-value">
            <app-uig-item-counter
              [control]="quantityControl"
              [readonly]="
                !item.updateable || readonly || options.isSaveForLater
              "
              [max]="1000"
              [entryNumber] = "item.entryNumber"
              [allowZero]="true"
              [savedCarts]="savedCarts"
              [cartId]="cartId"
              [userId]="userId"
              >
            </app-uig-item-counter>
          </div>
        </div>
        <!-- Total -->
        @if (options.isSaveForLater) {
          <div
            class="cx-total"
            [ngClass]="compact ? '' : ' col-md-3'"
            >
            <div
              class="cx-label"
              [ngClass]="
                compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'
              "
              >
              {{ "saveForLaterItems.stock" | cxTranslate }}
            </div>
            @if (item.product?.stock?.stockLevel >= 0) {
              <div
                class="cx-value"
                >
                {{ item.product.stock.stockLevel }}
              </div>
            } @else {
              <div class="cx-value">
                {{ "saveForLaterItems.forceInStock" | cxTranslate }}
              </div>
            }
          </div>
        } @else {
          @if (item.totalPrice) {
            <div
              class="cx-total"
              [ngClass]="compact ? '' : ' col-md-2'">
              <div class="cx-label"
                [ngClass]="compact ? '' : ' d-block d-md-none d-lg-none d-xl-none'">
                {{ "uigCartItems.total" | cxTranslate }}
              </div>
              <div class="cx-value">{{ item.totalPrice.formattedValue }}</div>
            </div>
          }
        }
      </div>
      <!-- Availability -->
      @if (isProductOutOfStock(item.product)) {
        <div
          class="cx-availability col-12">
          {{ "addToCart.outOfStock" | cxTranslate }}
        </div>
      }

      <!-- Item Bundle Details Outlet -->
      <ng-template [cxOutlet]="CartOutlets.ITEM_BUNDLE_DETAILS"> </ng-template>

      <!-- Promotion -->
      <!-- <cx-promotions [promotions]="item.promotions"></cx-promotions> -->
      @if (showNotes) {
        <app-uig-cart-notes
          class="col-9 col-sm-6"
          [cartItem]="item"
          [cartId]="cartId"
          [readonly]="readonly">
        </app-uig-cart-notes>
      }

      @if (!hideBulkyGoods && item.product.bulkyGoods) {
        <div>
          <img src="assets/images/availability/bulkyGoods.png"
            title="{{ 'product.deliveryCostBulkyDirect'  | cxTranslate : getTranslateOptions(item.product) }}" />
            <span class="product-deliveryCostBulkyDirect__label">
              {{ 'product.deliveryCostBulkyDirect' | cxTranslate : getTranslateOptions(item.product) }}
            </span>
          </div>
        }

        <!-- Actions -->
        @if ((!readonly || options.isSaveForLater) && item.updateable) {
          <div
            class="cx-actions">
            @if (!isProductOutOfStock(item.product)) {
          <ng-container *ngTemplateOutlet="
                          options.optionalBtn;
                          context: {
                            $implicit: { loading: quantityControl.disabled, item: item }
                          }
                        ">
            </ng-container>
          }
          @if (!hideDeleteButton) {
            <div class="col-md-3 cx-remove-btn">
              <button class="link cx-action-link"
                [disabled]="quantityControl.disabled"
                (click)="removeItem()"
                attr.aria-label="{{ 'addToCart.removeFromCart' | cxTranslate }}">
                {{ "common.remove" | cxTranslate }}
              </button>
            </div>
          }
        </div>
      }
    </div>
  </div>

</ng-template>
